import { ActionLink, EmptyState, PageLayout } from '../components/index.js';

export function NotFoundPage() {
  return (
    // `readable`, not the shell's `wide` default (2026-09-20): this page's
    // entire content is one centered message and a single link, which a
    // wide container would strand in a sea of empty parchment rather than
    // "matching" anything.
    <PageLayout width="readable" className="py-10">
      <EmptyState
        // This page's whole content is the empty state, so its title is the
        // page's `<h1>` — every other route gets one from `PageHeader` or its
        // own hero.
        headingLevel={1}
        illustration="loadingSplash"
        title="This page wandered off"
        description="Nothing lives at that address. Head back home and pick a game instead."
        action={
          <ActionLink to="/" variant="primary" showArrow>
            Back to home
          </ActionLink>
        }
      />
    </PageLayout>
  );
}
